/* Preserve Inbox's own controls; expose its launcher from the document flow on mobile. */
(() => {
  const triggers = [...document.querySelectorAll('[data-chp-inbox]')];
  if (!triggers.length) return;
  let bound = false;
  const connect = () => {
    if (bound) return true;
    const host = document.querySelector('shopify-chat');
    const root = host && host.shadowRoot;
    const launcher = root && root.querySelector('button[part="activator"]');
    if (!launcher) return false;
    bound = true;
    const sync = () => {
      const active = root.querySelector('button[part="activator"]');
      const open = active && active.getAttribute('aria-expanded') === 'true';
      document.body.classList.toggle('chp-pdp-inbox-open', Boolean(open));
      triggers.forEach(button => button.setAttribute('aria-expanded', String(Boolean(open))));
    };
    triggers.forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        const active = root.querySelector('button[part="activator"]');
        if (!active) return;
        document.body.classList.add('chp-pdp-inbox-open');
        if (active.getAttribute('aria-expanded') !== 'true') active.click();
      });
    });
    new MutationObserver(sync).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['aria-expanded']});
    document.body.classList.add('chp-pdp-inbox-ready');
    sync();
    return true;
  };
  if (!connect()) {
    let tries = 0;
    const timer = setInterval(() => { if (connect() || ++tries >= 60) clearInterval(timer); }, 500);
  }
})();
